import { styled } from "@mui/material/styles";

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.15,
}));
